import "./select.scss"
import React, { useState } from 'react';

const Select = ({value, options, placeholder, onChange, className, disabled, maxOptions }) => {
    const [selectedOption, setSelectedOption] = useState("");

    const displayedOptions = maxOptions
        ? options.slice(0, maxOptions)
        : options;


    return (
        <div className="custom-select">
            <select value={value} onChange={onChange}  className={className} disabled={disabled}>
                <option value='' disabled hidden>{placeholder}</option>
                {displayedOptions.map((option, index) => (
                    <option
                        key={option.value ?? index}
                        value={option.value}
                        className={className}
                    >
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default Select;

